interface Review {
  id: string;
  name: string;
  avatar: string;
  role: string;
  rating: number;
  title: string;
  content: string;
}

interface ReviewCardProps {
  review: Review;
  faded?: boolean;
}

export default function ReviewCard({ review, faded }: ReviewCardProps) {
  return (
    <div className={`bg-background-50 rounded-lg p-5 border border-background-200/60 ${faded ? 'opacity-60' : ''}`}>
      <div className="flex items-center gap-0.5 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <span
            key={i}
            className={`text-sm ${i < review.rating ? 'text-accent-500' : 'text-foreground-300'}`}
          >
            ★
          </span>
        ))}
      </div>
      <h5 className="text-sm font-semibold text-foreground-900 mb-2">{review.title}</h5>
      <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-4">{review.content}</p>
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
          <img
            src={review.avatar}
            alt={review.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div>
          <p className="text-xs font-medium text-foreground-800">{review.name}</p>
          <p className="text-[10px] text-foreground-500">{review.role}</p>
        </div>
      </div>
    </div>
  );
}